var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"notifications-link",attrs:{"href":"/announcements","data-testid":"elem_u_000152"}},[_c('v-icon',{attrs:{"color":"#737373","data-testid":"elem_u_000153"}},[_vm._v(" notifications_none ")]),(_vm.hasUnread)?_c('div',{staticClass:"has-unread",attrs:{"data-testid":"elem_u_003027"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }